import { Chart } from 'chart.js';

/* Libraries */
import { useReactToPrint } from 'react-to-print';

const SavePDFButton = ({ pdfRef, fileName = '', btnColor = 'primary' }) => {

    const onClickSavePDF = () => {
        handlePrint()
    }

    const handlePrint = useReactToPrint({
        contentRef: pdfRef,
        documentTitle: fileName ? fileName : "KGS PDF",
        onBeforePrint: async () => {
            // console.log("printBefore");

            for (let id in Chart.instances) {
                Chart.instances[id].resize(550, 300);
            }
        },
        onAfterPrint: () => {
            // console.log("printAfter");

            for (let id in Chart.instances) {
                Chart.instances[id].resize();
            }
        },
        onPrintError: (errorLocation, error) => {
            console.error("pdf출력에러");
            console.log(errorLocation);
            console.log(error);
        }
    });


    return (
        <button type='button' className={`btn btn-3 btn-${btnColor}`} onClick={onClickSavePDF}>PDF 저장</button>
    )
}

export default SavePDFButton